import React, { memo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AssignPhoneNumberModal from './assign-phone-number-modal';
import { getUsersListRequest, assignPhoneNumberRequest, bulkAssignPhoneNumberRequest } from '../../../../../../extra-actions';
import { IProps } from './types';
import { RootState } from '../../../../../../../../store/root-reducer';

const AssignPhoneNumberModalContainer: React.FC<IProps> = (props) => {
  const { selectedPhoneNumbers, deSelectedPhoneNumbers, isSelectAllAcrossPages, phoneNumberFilters, searchText, convertFiltersToAPIFormat } = props;
  const dispatch = useDispatch();
  const teamMembersList = useSelector((state: RootState) => state?.dialer?.teamMembersList || []);
  const assignPhoneNumberRequestState = useSelector((state: RootState) => state?.dialer?.assignPhoneNumberRequest);
  const bulkAssignPhoneNumberRequestState = useSelector((state: RootState) => state?.dialer?.bulkAssignPhoneNumberRequest);

  const getTeamMembersListRequest = useCallback(() => {
    dispatch(getUsersListRequest());
  }, [dispatch]);

  const handleAssignSubmit = useCallback((teamMemberId: number) => {
    const selectedCount = selectedPhoneNumbers?.length || 0;
    const deSelectedCount = deSelectedPhoneNumbers?.length || 0;

    if (selectedCount > 0 && deSelectedCount === 0 && selectedPhoneNumbers) {
      // Use assignPhoneNumber API
      const phoneNumberIds = selectedPhoneNumbers.map((item) => item.id);
      dispatch(assignPhoneNumberRequest({
        phoneNumberIds,
        userId: teamMemberId,
      }));
    } else if (selectedCount === 0 && deSelectedCount >= 0 && deSelectedPhoneNumbers && isSelectAllAcrossPages) {
      // Use bulkAssignPhoneNumber API
      const deselectedPhoneNumberIds = deSelectedPhoneNumbers.map((item) => item.id);
      const apiFilters = convertFiltersToAPIFormat?.(phoneNumberFilters, searchText);
      dispatch(bulkAssignPhoneNumberRequest({
        ...(deselectedPhoneNumberIds.length > 0 && { deselectedPhoneNumberIds }),
        phoneNumberFilters: apiFilters,
        userId: teamMemberId,
      }));
    }
  }, [selectedPhoneNumbers, deSelectedPhoneNumbers, phoneNumberFilters, searchText, convertFiltersToAPIFormat, dispatch]);

  return (
    <AssignPhoneNumberModal
      {...props}
      getTeamMembersListRequest={getTeamMembersListRequest}
      teamMembersList={teamMembersList}
      selectedPhoneNumbers={selectedPhoneNumbers}
      deSelectedPhoneNumbers={deSelectedPhoneNumbers}
      isSelectAllAcrossPages={isSelectAllAcrossPages}
      onSubmit={handleAssignSubmit}
      assignPhoneNumberRequestStatus={assignPhoneNumberRequestState?.status}
      bulkAssignPhoneNumberRequestStatus={bulkAssignPhoneNumberRequestState?.status}
    />
  );
};

export default memo(AssignPhoneNumberModalContainer);

